import { Breadcrumbs, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { Theme } from "../../config/aws-exports";
import { HeadingPrimary } from "../../components/Styles/Heading";
import CardPrimary from "../../components/Card/Card.Primary";
import { useSelector, useDispatch } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import config from "../../config/aws-exports";
import { API } from "@aws-amplify/api"; // import { Skeleton } from "@mui/material";s
import { session } from "../../redux/Session/Session";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { SkeletonData } from "../Dashboard/Dashboard";
import emptysearch from "../../assets/Nothing here yet.gif";

const Wishlist = () => {
  // const interests = useSelector((state) => state.interests.value);
  const navigate = useNavigate();
  const userDetails = useSelector(authData);
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [myInterests, setMyInterests] = useState([]);
  console.log({ myInterests });

  useEffect(() => {
    getMyWishlist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getMyWishlist() {
    setLoading(true);
    try {
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          tenant: userDetails.tenant,
          eid: userDetails.username,
          ur_id: userDetails?.uData?.ur_id,
          schema: config.schema,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      console.log(
        "recent view body response===" + JSON.stringify(bodyParam.body),
      );
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getMyInterests",
        bodyParam,
      );
      setMyInterests(response);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  const breadcrumbs = [
    <Link to="/dashboard">Dashboard</Link>,
    <Typography key="3" color={Theme.color.black}>
      Wishlist
    </Typography>,
  ];
  return (
    <>
      <Stack spacing={2} margin={{ xs: "1rem", sm: "3rem" }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ color: Theme.color.text }}
        >
          {breadcrumbs}
        </Breadcrumbs>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <HeadingPrimary> My Wishlist</HeadingPrimary>
        </Stack>
        {isLoading ? (
          <>
            <SkeletonData />
          </>
        ) : (
          <>
            <Grid container spacing={2}>
              {myInterests?.items?.map(
                (item, idx) =>
                  item.type === 3 && (
                    <Grid xs={12} sm={6} md={4} lg={3}>
                      <CardPrimary
                        key={idx}
                        img={
                          item?.tid &&
                          `https://${
                            config.aws_cloudfront_url
                          }/${config.aws_org_id.toLowerCase()}-resources/images/${
                            item.type === 1 ? "topic" : "session"
                          }-images/${item?.tid}.png`
                        }
                        mediaSx={{
                          width: "100%",
                          height: 180,
                          aspectRatio: "16/9",
                          objectFit: "cover",
                          objectPosition: "center",
                        }}
                        Auth={true}
                        title={
                          item.tname[0].title.length > 30
                            ? `${item.tname[0].title.slice(0, 30)}...`
                            : item.tname[0].title
                        }
                        addToFavorite={true}
                        sessionDate={
                          item?.tname[0]?.date_list !== undefined &&
                          item?.tname[0]?.date_list !== null &&
                          item.tname[0].date_list[0].combineStartTime !==
                            undefined
                            ? moment(
                                new Date(
                                  item.tname[0].date_list[0].combineStartTime,
                                ).getTime(),
                              ).format("DD MMM YYYY")
                            : item?.startdate
                              ? moment(parseInt(item?.startdate)).format(
                                  "DD MMM YYYY",
                                )
                              : "yet to be scheduled"
                        }
                        handleLocation={() => {
                          navigate(`/session?sid=${item.tid}`);
                          dispatch(session({ ...item, path: "wishlist" }));
                        }}
                      />
                    </Grid>
                  ),
                // : item.type === 1 && (
                //   <Grid xs={12} sm={6} md={4} lg={3}>
                //     <CardPrimary
                //       key={idx}
                //       img={
                //         item?.tid &&
                //         `https://${
                //           config.aws_cloudfront_url
                //         }/${config.aws_org_id.toLowerCase()}-resources/images/${
                //           "topic"
                //         }-images/${item?.tid}.png`
                //       }
                //       Auth={true}
                //       title={item.tname[0].title}
                //       addToFavorite={true}

                //       handleLocation={() => {
                //         navigate(`/course?id=${item.tid}`);
                //         dispatch(session({ ...item, path: "wishlist" }));
                //       }}
                //     />
                //   </Grid>
                // )
              )}
            </Grid>
            {!myInterests?.items?.find((item) => item.type === 3) && (
              <div
                style={{
                  height: "60vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img src={emptysearch} alt="emptysearch" />
                {/* <h3>Nothing here yet!</h3> */}
              </div>
            )}
          </>
        )}
      </Stack>
    </>
  );
};

export default Wishlist;
